<template>
    <CModal
        :show.sync="showModal"
        size="sm"
        color="primary">
        <template>
            <div slot="header">
                <CIcon name="cil-bell" /> Новый заказ
            </div>
            <div slot="body-wrapper" class="modal-body">
                <div class="text-center">
                    <h5>Поступил новый заказ №{{ order.id }}</h5>
                    <p v-if="order.customer" class="mb-1">
                        <strong>Клиент:</strong> {{ order.customer.name }}
                    </p>
                    <p v-if="order.address" class="mb-1">
                        <strong>Адрес:</strong> {{ order.address }}
                    </p>
                    <p v-if="order.total" class="mb-1">
                        <strong>Сумма:</strong> {{ order.total }} ₽
                    </p>
                </div>
            </div>
            <div slot="footer">
                <CButton 
                    color="primary" 
                    @click="goToOrder">
                    Перейти к заказу
                </CButton>
                <CButton 
                    color="secondary" 
                    @click="closeModal">
                    Закрыть
                </CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
export default {
    name: 'NewOrderNotification',
    
    data() {
        return {
            showModal: false,
            order: {}
        }
    },

    mounted() {
        this.$root.$on('showNewOrderNotification', this.showNotification);
    },

    beforeDestroy() {
        this.$root.$off('showNewOrderNotification', this.showNotification);
    },

    methods: {
        showNotification(order) {
            this.order = order;
            this.showModal = true;
            
            setTimeout(() => {
                if (this.showModal) {
                    this.showModal = false;
                }
            }, 10000);
        },

        goToOrder() {
            this.showModal = false;
            this.$router.push(`/orders/${this.order.id}`);
        },

        closeModal() {
            this.showModal = false;
        }
    }
}
</script>

<style scoped>
.modal-body {
    padding: 1rem;
}

.modal-body h5 {
    color: #32a852;
    margin-bottom: 1rem;
}

.modal-body p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}
</style> 